import cx from 'classnames';

import testingConstants from 'utils/testingConstants';

const UNREAD_SEPARATOR_ID = 'unread-separator';

type ChatTimelineSeparatorProps = {
  label: string;
  variant?: 'date' | 'unread';
};

const ChatTimelineSeparator = ({ label, variant = 'date' }: ChatTimelineSeparatorProps) => {
  const isUnread = variant === 'unread';

  return (
    <div
      id={isUnread ? UNREAD_SEPARATOR_ID : undefined}
      data-testid={testingConstants.chatTimelineSeparator}
      className="flex items-center gap-4 w-full shrink-0 my-2"
    >
      <div className="flex-1 h-px bg-gray-30" />
      <div
        data-testid={testingConstants.chatTimelineSeparatorPill}
        className={cx(
          'flex items-center justify-center h-6 px-3 rounded-full shrink-0',
          isUnread ? 'bg-tertiary-50 text-white' : 'bg-gray-10 border border-gray-30 text-gray-60'
        )}
      >
        <span className="text-size-xs font-light whitespace-nowrap">{label}</span>
      </div>
      <div className="flex-1 h-px bg-gray-30" />
    </div>
  );
};

export { UNREAD_SEPARATOR_ID };
export default ChatTimelineSeparator;
